import { render } from "./SubmitButtonSm.vue?vue&type=template&id=616f4abc&ts=true"
import script from "./SubmitButtonSm.vue?vue&type=script&lang=ts"
export * from "./SubmitButtonSm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__